import { IntegrationSystem } from "../../types";
import { MailchimpConnectView } from "./ConnectView";
import { MailchimpSettingsView } from "./SettingsView";

export const MailchimpSystem: IntegrationSystem = {
  ConnectView: MailchimpConnectView,
  SettingsView: MailchimpSettingsView
};
